import React, { useRef, useState, useEffect } from "react";
import { motion, AnimatePresence } from "motion/react";

// ============================
//  FeatureSection Component
// ============================
export function FeatureSection({
  title,
  description,
  features,
  mockupType,
  reversed = false,
  metric,
}) {
  const sectionRef = useRef(null);

  return (
    <section ref={sectionRef} className="py-10 md:py-32 md:px-5">
      <div className="max-w-[1400px] mx-auto">
        <div
          className={`grid grid-cols-1 lg:grid-cols-2 gap-20 items-center ${reversed ? "lg:grid-flow-dense" : ""
            }`}
        >
          {/* TEXT CONTENT */}
          <motion.div
            className={reversed ? "lg:col-start-2" : ""}
            initial={{ opacity: 0, x: reversed ? 50 : -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
          >
            {/* Title */}
            <h2 className=" mb-6 features_title">{title}</h2>

            {/* Description */}
            <p className="text-[--color-text-secondary] mb-8">
              {description}
            </p>

            {/* Feature List */}
            <ul className="space-y-4 mb-8">
              {features.map((feature, idx) => (
                <motion.li
                  key={idx}
                  className="flex items-start gap-4 sm:gap-4"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.1 }}
                >
                  <span className="feature-icon"
                    //           className="text-[--color-primary]  text-lg sm:text-xl md:text-2xl lg:text-3xl
                    // font-bold leading-none"
                    style={{ fontSize: "1.5rem", fontWeight: 700 }}
                  >
                    ✓
                  </span>
                  <span className="features_List_Class"
                  //           className="text-[--color-text-primary] features_class text-base sm:text-base md:text-lg lg:text-xl features_List_Class
                  // leading-relaxed font-normal"
                  // style={{ fontSize: "1.125rem", lineHeight: 1.6 }}
                  >
                    {feature}
                  </span>
                </motion.li>
              ))}
            </ul>

            {/* Metric Before/After */}
            {metric && (
              <motion.div
                className="bg-[--color-bg-gray] rounded-2xl p-4 md:p-8"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <div className="flex items-center justify-between">
                  <div className="text-center flex-1">
                    <div
                      className="text-red-500 mb-2 text-xl md:text-2xl"
                    // style={{ fontSize: "2rem", fontWeight: 700 }}
                    >
                      {metric.before}
                    </div>
                    <div
                      className="text-[--color-text-muted]"
                      style={{ fontSize: "0.875rem" }}
                    >
                      Before
                    </div>
                  </div>

                  <div
                    className="text-[--color-text-muted] text-2xl md:text-4xl"
                  // style={{ fontSize: "2rem" }}
                  >
                    →
                  </div>

                  <div className="text-center flex-1">
                    <div
                      className="text-[--color-primary] mb-2 text-xl md:text-2xl"
                      style={{ fontSize: "2rem", fontWeight: 700 }}
                    >
                      {metric.after}
                    </div>
                    <div
                      className="text-[--color-text-muted] "
                    // style={{ fontSize: "0.875rem" }}
                    >
                      After
                    </div>
                  </div>
                </div>

                <div
                  className="text-center mt-4 text-[--color-text-secondary]"
                  style={{ fontSize: "1rem", fontWeight: 500 }}
                >
                  {metric.label}
                </div>
              </motion.div>
            )}
          </motion.div>

          {/* MOCKUP BLOCK */}
          <motion.div
            className={reversed ? "lg:col-start-1 lg:row-start-1" : ""}
            initial={{ opacity: 0, x: reversed ? -50 : 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
          >
            <AnimatedMockup type={mockupType} />
          </motion.div>
        </div>
      </div>
    </section>
  );
}

// ============================
//  Animated Mockups
// ============================
function AnimatedMockup({ type }) {
  const mockups = {
    dashboard: <DashboardMockup />,
    workflow: <WorkflowMockup />,
    roles: <RolesMockup />,
  };

  return mockups[type];
}

// ============================
//  Dashboard Mockup
// ============================
// function DashboardMockup() {
//   const items = [
//     { icon: "🔴", text: "Review Q4 financial statements", urgent: true },
//     { icon: "🟡", text: "Update client tax filing", urgent: false },
//     { icon: "🟢", text: "Prepare audit checklist", urgent: false },
//     { icon: "⚪", text: "Schedule team sync meeting", urgent: false },
//   ];

//   return (
//     <div
//       className="rounded-3xl p-4 sm:p-8 md:p-12 lg:p-16"
//       style={{
//         background: "linear-gradient(135deg, #F5F5F7 0%, #E8E8ED 100%)",
//         boxShadow: "0px 20px 80px rgba(9, 58, 91, 0.12)",
//       }}
//     >
//       {/* Mock window top bar */}
//       <div
//         className="rounded-t-3xl flex items-center px-5"
//         style={{ height: "40px", background: "#093A5B" }}
//       >
//         <div className="flex gap-2">
//           <div className="w-3 h-3 rounded-full bg-white/30"></div>
//           <div className="w-3 h-3 rounded-full bg-white/30"></div>
//           <div className="w-3 h-3 rounded-full bg-white/30"></div>
//         </div>
//       </div>

//       {/* Main content */}
//       <div
//         className="bg-white rounded-b-xl p-2 sm:p-4 md:p-8 min-h-[350px]"
//       // style={{
//       //   minHeight: "",
//       //   boxShadow: "0px 10px 40px rgba(0,0,0,0.08)",
//       // }}
//       >
//         <div
//           className="text-[--color-text-primary] mb-8"
//           style={{ fontSize: "1.5rem", fontWeight: 600 }}
//         >
//           What Needs Attention
//         </div>

//         <div className="space-y-4">
//           {items.map((item, idx) => (
//             <motion.div
//               key={idx}
//               className="bg-[--color-bg-gray] p-3 md:p-5 rounded-xl border-l-4 border-[--color-primary] flex items-center gap-4"
//               initial={{ opacity: 0, x: -20 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ delay: idx * 0.15 }}
//             >
//               <motion.span
//                 style={{ fontSize: "1.25rem" }}
//                 animate={
//                   item.urgent ? { scale: [1, 1.2, 1] } : {}
//                 }
//                 transition={
//                   item.urgent ? { repeat: Infinity, duration: 2 } : {}
//                 }
//               >
//                 {item.icon}
//               </motion.span>

//               <span
//                 className="text-[--color-text-primary] flex-1"
//                 style={{ fontSize: "1rem" }}
//               >
//                 {item.text}
//               </span>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }
function DashboardMockup() {
  const stacks = [
    {
      id: "urgent",
      title: "Urgent",
      emoji: "🔴",
      tasksLabel: "3 tasks",
      count: 3,
      iconBg: "rgba(255, 59, 48, 0.082)",
      iconShadow: "0 0 26px rgba(255, 59, 48, 0.204)",
      chipBg: "rgba(255, 59, 48, 0.063)",
      chipColor: "rgb(255, 59, 48)",
      dotColor: "rgb(255, 59, 48)",
      progress: 90,
      gradientFrom: "rgba(255, 59, 48, 1)",
      gradientTo: "rgba(255, 59, 48, 0.667)",
      tasks: ["Q4 Financial Review", "Tax Filing Due", "Client Meeting"],
      offset: { left: 0, top: 0, z: 3 },
    },
    {
      id: "today",
      title: "Today",
      emoji: "🟡",
      tasksLabel: "7 tasks",
      count: 7,
      iconBg: "rgba(255, 149, 0, 0.082)",
      iconShadow: "0 0 26px rgba(255, 149, 0, 0.204)",
      chipBg: "rgba(255, 149, 0, 0.063)",
      chipColor: "rgb(255, 149, 0)",
      dotColor: "rgb(255, 149, 0)",
      progress: 60,
      gradientFrom: "rgba(255, 149, 0, 1)",
      gradientTo: "rgba(255, 149, 0, 0.667)",
      tasks: ["Prepare Audit", "Update Records", "Team Sync"],
      offset: { left: 40, top: 60, z: 2 },
    },
    {
      id: "week",
      title: "This Week",
      emoji: "🟢",
      tasksLabel: "12 tasks",
      count: 12,
      iconBg: "rgba(15, 157, 146, 0.082)",
      iconShadow: "0 0 26px rgba(15, 157, 146, 0.204)",
      chipBg: "rgba(15, 157, 146, 0.063)",
      chipColor: "rgb(15, 157, 146)",
      dotColor: "rgb(15, 157, 146)",
      progress: 30,
      gradientFrom: "rgba(15, 157, 146, 1)",
      gradientTo: "rgba(15, 157, 146, 0.667)",
      tasks: ["Plan Quarter", "Review Budget", "Client Check-in"],
      offset: { left: 80, top: 120, z: 1 },
    },
  ];

  return (
    <div
      className="rounded-3xl p-4 sm:p-8 md:p-12 lg:p-16"
      style={{
        // background: "linear-gradient(135deg, #F5F5F7 0%, #E8E8ED 100%)",
        // boxShadow: "0px 20px 80px rgba(9, 58, 91, 0.12)",
      }}
    >
      {/* Mock window top bar */}
      <div
        className=""
      // rounded-t-3xl flex items-center px-5
      // style={{ height: "40px", background: "#093A5B" }}
      >
        {/* <div className="flex gap-2">
          <div className="w-3 h-3 rounded-full bg-white/30"></div>
          <div className="w-3 h-3 rounded-full bg-white/30"></div>
          <div className="w-3 h-3 rounded-full bg-white/30"></div>
        </div> */}
      </div>

      {/* Main content */}
      <div className="">
        {/* bg-white rounded-b-xl p-2 sm:p-4 md:p-8 min-h-[350px] */}
        <div className="flex items-center justify-between mb-8">
          {/* <div
            className="text-[--color-text-primary]"
            style={{ fontSize: "1.5rem", fontWeight: 600 }}
          >
            What Needs Attention
          </div> */}
          <div
            className="hidden md:inline-flex text-[--color-text-muted]"
            style={{ fontSize: "0.875rem" }}
          >
            Urgent, today, and this week — all in one glance.
          </div>
        </div>

        {/* Stacked cards */}
        <div
          className="relative"
          style={{ perspective: "1500px", minHeight: "500px" }}
        >
          {/* Soft glow behind cards */}
          <div
            className="absolute rounded-full blur-3xl opacity-30"
            style={{
              width: 400,
              height: 400,
              background:
                "radial-gradient(circle, rgb(15, 157, 146) 0%, transparent 70%)",
              left: "50%",
              top: "55%",
              transform: "translate(-50%, -50%) scale(1.02)",
              zIndex: 0,
            }}
          ></div>

          {stacks.map((group, idx) => (
            <motion.div
              key={group.id}
              className="absolute bg-white rounded-3xl p-8 shadow-2xl"
              style={{
                width: 380,
                left: group.offset.left,
                top: group.offset.top,
                zIndex: group.offset.z,
                border: "1px solid rgba(9, 58, 91, 0.08)",
              }}
              initial={{ opacity: 0, y: 40, scale: 0.97 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.12 }}
              whileHover={{
                y: -8,
                boxShadow: "0 25px 60px rgba(0,0,0,0.18)",
              }}
            >
              {/* Card header */}
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div
                    className="w-12 h-12 rounded-2xl flex items-center justify-center"
                    style={{
                      background: group.iconBg,
                      boxShadow: group.iconShadow,
                    }}
                  >
                    <span style={{ fontSize: "1.5rem" }}>{group.emoji}</span>
                  </div>
                  <div>
                    <div
                      className="text-[--color-text-primary]"
                      style={{ fontSize: "1.25rem", fontWeight: 600 }}
                    >
                      {group.title}
                    </div>
                    <div
                      className="text-[--color-text-muted]"
                      style={{ fontSize: "0.875rem" }}
                    >
                      {group.tasksLabel}
                    </div>
                  </div>
                </div>
                <div
                  className="rounded-full px-4 py-2"
                  style={{
                    background: group.chipBg,
                    color: group.chipColor,
                    fontSize: "1.5rem",
                    fontWeight: 700,
                  }}
                >
                  {group.count}
                </div>
              </div>

              {/* Task list */}
              <div className="space-y-3">
                {group.tasks.map((task, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-3 p-3 rounded-xl bg-[--color-bg-gray] hover:bg-gray-100 cursor-pointer transition-colors"
                  >
                    <div
                      className="w-2 h-2 rounded-full"
                      style={{ background: group.dotColor }}
                    ></div>
                    <span
                      className="text-[--color-text-primary]"
                      style={{ fontSize: "0.9375rem" }}
                    >
                      {task}
                    </span>
                  </div>
                ))}
              </div>

              {/* Progress bar */}
              <div className="mt-6 pt-4 border-t border-gray-100">
                <div className="flex justify-between mb-2">
                  <span
                    className="text-[--color-text-muted]"
                    style={{ fontSize: "0.75rem" }}
                  >
                    Progress
                  </span>
                  <span
                    className="text-[--color-primary]"
                    style={{ fontSize: "0.75rem", fontWeight: 600 }}
                  >
                    {group.progress}%
                  </span>
                </div>
                <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full"
                    style={{
                      width: `${group.progress}%`,
                      background: `linear-gradient(90deg, ${group.gradientFrom}, ${group.gradientTo})`,
                    }}
                  ></div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ============================
//  Workflow Mockup
// ============================

// export default function WorkflowMockup() {
//   const [progress, setProgress] = useState(0);

//   useEffect(() => {
//     const id = setInterval(() => {
//       setProgress((p) => (p >= 100 ? 0 : p + 2));
//     }, 100);
//     return () => clearInterval(id);
//   }, []);

//   const steps = [
//     "Gather requirements",
//     "Review with team",
//     "Execute changes",
//     "Quality check",
//   ];

//   return (
//     <div
//       className="rounded-3xl p-4 sm:p-8 md:p-12 lg:p-16 "
//       style={{
//         // background: "linear-gradient(135deg, #F5F5F7, #E8E8ED)",
//         // boxShadow: "0px 20px 80px rgba(9,58,91,0.12)",
//       }}
//     >
//       {/* TOP WINDOW BAR */}
//       <div
//         className="rounded-t-3xl flex items-center px-5"
//         style={{ height: "40px", background: "#093A5B" }}
//       >
//         <div className="flex gap-2">
//           <div className="w-3 h-3 rounded-full bg-white/30"></div>
//           <div className="w-3 h-3 rounded-full bg-white/30"></div>
//           <div className="w-3 h-3 rounded-full bg-white/30"></div>
//         </div>
//       </div>

//       {/* CONTENT AREA */}
//       <div
//         className="bg-white rounded-b-xl p-4 md:p-8"
//         style={{ minHeight: "400px", boxShadow: "0 10px 40px rgba(0,0,0,0.08)" }}
//       >
//         <div className="text-gray-900 mb-8 text-2xl font-semibold">
//           Task in Progress
//         </div>

//         {/* PROGRESS BAR */}
//         <div className="mb-8">
//           <div className="flex justify-between mb-3">
//             <span className="text-gray-500">Completion</span>
//             <span className="text-[#093A5B] font-semibold">
//               {progress}%
//             </span>
//           </div>

//           <div className="h-3 bg-gray-200 rounded-full overflow-hidden">
//             <motion.div
//               className="h-full"
//               animate={{
//                 width: `${progress}%`,
//                 background: "linear-gradient(to right, #093A5B, #0F9D92)",
//               }}
//               transition={{ duration: 0.2, ease: "linear" }}
//             />
//           </div>
//         </div>

//         {/* STEP LIST */}
//         <div className="space-y-4">
//           {steps.map((step, idx) => {
//             const threshold = (idx + 1) * 25; // step unlocks every 25%

//             return (
//               <motion.div
//                 key={idx}
//                 className="flex items-center gap-4"
//                 initial={{ opacity: 0.3 }}
//                 animate={{
//                   opacity: progress >= idx * 25 ? 1 : 0.3,
//                 }}
//               >
//                 {/* Step Circle */}
//                 <div
//                   className={`w-8 h-8 rounded-full flex items-center justify-center transition-all
//                   ${progress >= threshold ? "bg-[#093A5B]" : "bg-gray-200"}
//                 `}
//                 >
//                   {progress >= threshold ? (
//                     <span className="text-white">✓</span>
//                   ) : (
//                     <span className="text-gray-500">{idx + 1}</span>
//                   )}
//                 </div>

//                 {/* Step Label */}
//                 <span
//                   className={`text-gray-900 transition-all ${progress >= idx * 25 ? "font-medium" : "font-normal"
//                     }`}
//                 >
//                   {step}
//                 </span>
//               </motion.div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function WorkflowMockup() {
//   const [progress, setProgress] = useState(0); // 0 → 100 loop

//   // Auto-animate progress like before
//   useEffect(() => {
//     const id = setInterval(() => {
//       setProgress((p) => (p >= 100 ? 0 : p + 2));
//     }, 120);
//     return () => clearInterval(id);
//   }, []);

//   const steps = [
//     {
//       key: "todo",
//       title: "To Do",
//       subtitle: "Step 1",
//       phaseTitle: "To Do Phase",
//       description: "Task created and waiting to be started",
//       statusLabel: "Active",
//       icon: "📋",
//       color: "#5856D6", // purple
//     },
//     {
//       key: "in-progress",
//       title: "In Progress",
//       subtitle: "Step 2",
//       phaseTitle: "In Progress Phase",
//       description: "Work has started and is moving ahead",
//       statusLabel: "Ongoing",
//       icon: "⚡",
//       color: "#FF9500", // amber / lightning feel
//     },
//     {
//       key: "review",
//       title: "Under Review",
//       subtitle: "Step 3",
//       phaseTitle: "Review Phase",
//       description: "Outputs are being checked before closure",
//       statusLabel: "In review",
//       icon: "👁️",
//       color: "#AF52DE", // soft violet
//     },
//     {
//       key: "closed",
//       title: "Closed",
//       subtitle: "Step 4",
//       phaseTitle: "Closed Phase",
//       description: "Task is completed and marked as closed",
//       statusLabel: "Done",
//       icon: "✓",
//       color: "#34C759", // green
//     },
//   ];

//   const stepWidth = 100 / steps.length;
//   const activeIndex = Math.min(
//     steps.length - 1,
//     Math.floor((progress / 100) * steps.length)
//   );

//   // Line goes from 10% → 90%, so dot travels across that span
//   const dotLeftPercent = 10 + (progress / 100) * 80;

//   return (
//     <div className=" p-4 sm:p-8 md:p-12 lg:p-16">
//       {/* Optional: keep the mock window bar for consistency */}
//       <div
//         className="flex items-center px-5 mb-2"
//       // style={{ height: "40px", background: "#093A5B" }}
//       >
//         {/* <div className="flex gap-2">
//           <div className="w-3 h-3 rounded-full bg-white/30" />
//           <div className="w-3 h-3 rounded-full bg-white/30" />
//           <div className="w-3 h-3 rounded-full bg-white/30" />
//         </div> */}
//       </div>

//       <div
//         className=" p-6 md:p-10"
//       // style={{ minHeight: "420px", boxShadow: "0 10px 40px rgba(0,0,0,0.08)" }}
//       >
//         <div className="text-gray-900 mb-8 text-xl md:text-2xl font-semibold text-center">
//           Simple, clear workflow to complete a task
//         </div>

//         <div className="relative min-h-[380px]">
//           {/* DASHED GRADIENT LINE */}
//           <div className="relative">
//             <svg
//               className="absolute top-1/2 left-0 w-full h-2 -translate-y-1/2"
//               style={{ zIndex: 0 }}
//             >
//               <defs>
//                 <linearGradient
//                   id="workflowLineGradient"
//                   x1="0%"
//                   y1="0%"
//                   x2="100%"
//                   y2="0%"
//                 >
//                   <stop offset="0%" stopColor="#093A5B" stopOpacity="0.2" />
//                   <stop offset="50%" stopColor="#0F9D92" stopOpacity="0.4" />
//                   <stop offset="100%" stopColor="#0F9D92" stopOpacity="0.2" />
//                 </linearGradient>
//               </defs>
//               <line
//                 x1="10%"
//                 y1="50%"
//                 x2="90%"
//                 y2="50%"
//                 stroke="url(#workflowLineGradient)"
//                 strokeWidth="3"
//                 strokeDasharray="8,8"
//               />
//             </svg>

//             {/* GLOWING PROGRESS DOT */}
//             <motion.div
//               className="absolute top-1/2 w-3 h-3 rounded-full"
//               style={{
//                 left: `${dotLeftPercent}%`,
//                 transform: "translateY(-50%)",
//                 background:
//                   "linear-gradient(135deg, rgb(15,157,146), rgb(52,199,89))",
//                 boxShadow: "0 0 20px rgba(15,157,146, 0.9)",
//                 zIndex: 5,
//               }}
//               animate={{ scale: [1, 1.2, 1] }}
//               transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
//             />

//             {/* STEPS */}
//             <div
//               className="flex justify-between items-center relative"
//               style={{ paddingTop: 100 }}
//             >
//               {steps.map((step, idx) => {
//                 const isActive = idx === activeIndex;
//                 const isCompleted = idx < activeIndex;

//                 const circleBg = isActive
//                   ? `linear-gradient(135deg, ${step.color}, ${step.color}CC)`
//                   : "#FFFFFF";

//                 const circleBorder = isActive
//                   ? `3px solid ${step.color}`
//                   : isCompleted
//                     ? `3px solid ${step.color}55`
//                     : "3px solid rgb(229,229,234)";

//                 const circleShadow = isActive
//                   ? `${step.color}40 0px 10px 40px`
//                   : "0 5px 20px rgba(0,0,0,0.08)";

//                 const labelColor = isActive
//                   ? step.color
//                   : "rgb(134,134,139)";

//                 const statusBg = `rgba(88, 86, 214, 0.082)`; // soft pill; looks fine for all

//                 return (
//                   <div
//                     key={step.key}
//                     className="flex flex-col items-center flex-1 relative"
//                     style={{ minWidth: `${stepWidth}%` }}
//                   >
//                     {/* CIRCLE + GLOW */}
//                     <motion.div
//                       className="relative mb-6"
//                       animate={{ scale: isActive ? 1.15 : 1 }}
//                       transition={{ type: "spring", stiffness: 260, damping: 20 }}
//                     >
//                       {isActive && (
//                         <div
//                           className="absolute inset-0 rounded-full"
//                           style={{
//                             background: "rgba(88, 86, 214, 0.125)",
//                             filter: "blur(10px)",
//                             transform: "scale(1.4)",
//                           }}
//                         />
//                       )}
//                       <div
//                         className="relative w-20 h-20 rounded-full flex items-center justify-center cursor-pointer"
//                         style={{
//                           background: circleBg,
//                           border: circleBorder,
//                           boxShadow: circleShadow,
//                         }}
//                       >
//                         <span
//                           style={{
//                             fontSize: "2rem",
//                             filter: isActive
//                               ? "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
//                               : "none",
//                           }}
//                         >
//                           {step.icon}
//                         </span>
//                       </div>
//                     </motion.div>

//                     {/* LABELS */}
//                     <div
//                       className="text-center"
//                       style={{
//                         color: labelColor,
//                         transform: isActive ? "scale(1.05)" : "scale(1)",
//                         transition: "all 0.25s ease",
//                       }}
//                     >
//                       <div
//                         style={{
//                           fontSize: "1.125rem",
//                           fontWeight: 600,
//                           marginBottom: 4,
//                         }}
//                       >
//                         {step.title}
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "0.8125rem",
//                           color: "rgb(134,134,139)",
//                         }}
//                       >
//                         {step.subtitle}
//                       </div>
//                     </div>

//                     {/* TOOLTIP CARD FOR ACTIVE STEP */}
//                     {isActive && (
//                       <motion.div
//                         className="absolute bg-white rounded-2xl p-3 shadow-2xl"
//                         style={{
//                           top: 200,
//                           width: 280,
//                           left: "50%",
//                           marginLeft: -140,
//                           border: `2px solid ${step.color}30`,
//                         }}
//                         initial={{ opacity: 0, y: 10 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         exit={{ opacity: 0, y: 10 }}
//                         transition={{ duration: 0.25 }}
//                       >
//                         <div
//                           className="text-[--color-text-primary] mb-3"
//                           style={{ fontSize: "1.125rem", fontWeight: 600 }}
//                         >
//                           {step.phaseTitle}
//                         </div>
//                         <div
//                           className="text-[--color-text-secondary] mb-4"
//                           style={{ fontSize: "0.875rem", lineHeight: 1.5 }}
//                         >
//                           {step.description}
//                         </div>
//                         <div className="flex items-center justify-between">
//                           <span
//                             className="text-[--color-text-muted]"
//                             style={{ fontSize: "0.75rem" }}
//                           >
//                             Status
//                           </span>
//                           <span
//                             className="px-3 py-1 rounded-full"
//                             style={{
//                               background: statusBg,
//                               color: step.color,
//                               fontSize: "0.75rem",
//                               fontWeight: 600,
//                             }}
//                           >
//                             {step.statusLabel}
//                           </span>
//                         </div>
//                       </motion.div>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// Step valu che 

// export default function WorkflowMockup() {
//   const steps = [
//     {
//       key: "todo",
//       title: "To Do",
//       subtitle: "Step 1",
//       phaseTitle: "To Do Phase",
//       description: "Task created and waiting to be started",
//       statusLabel: "Active",
//       icon: "📋",
//       color: "#5856D6", // purple
//     },
//     {
//       key: "in-progress",
//       title: "In Progress",
//       subtitle: "Step 2",
//       phaseTitle: "In Progress Phase",
//       description: "Work has started and is moving ahead",
//       statusLabel: "Ongoing",
//       icon: "⚡",
//       color: "#FF9500", // amber
//     },
//     {
//       key: "review",
//       title: "Under Review",
//       subtitle: "Step 3",
//       phaseTitle: "Review Phase",
//       description: "Outputs are being checked before closure",
//       statusLabel: "In review",
//       icon: "👁️",
//       color: "#AF52DE", // violet
//     },
//     {
//       key: "closed",
//       title: "Closed",
//       subtitle: "Step 4",
//       phaseTitle: "Closed Phase",
//       description: "Task is completed and marked as closed",
//       statusLabel: "Done",
//       icon: "✓",
//       color: "#34C759", // green
//     },
//   ];

//   const [activeIndex, setActiveIndex] = useState(0);

//   const stepWidth = 100 / steps.length;

//   // Dot moves between 10% → 90% across all 4 steps
//   const dotLeftPercent =
//     10 + (activeIndex / (steps.length - 1 || 1)) * 80;

//   const handleStepClick = (idx: number) => {
//     // If clicking the same step → go to next (last → first)
//     setActiveIndex((current) => {
//       if (current === idx) {
//         return (current + 1) % steps.length;
//       }
//       // If clicking a different step → jump directly
//       return idx;
//     });
//   };

//   return (
//     <div className="p-4 sm:p-8 md:p-12 lg:p-16">
//       <div className="p-6 md:p-10">
//         <div className="text-gray-900 mb-8 text-xl md:text-2xl font-semibold text-center">
//           Simple, clear workflow to complete a task
//         </div>

//         <div className="relative min-h-[380px]">
//           {/* DASHED GRADIENT LINE */}
//           <div className="relative">
//             <svg
//               className="absolute top-1/2 left-0 w-full h-2 -translate-y-1/2"
//               style={{ zIndex: 0 }}
//             >
//               <defs>
//                 <linearGradient
//                   id="workflowLineGradient"
//                   x1="0%"
//                   y1="0%"
//                   x2="100%"
//                   y2="0%"
//                 >
//                   <stop offset="0%" stopColor="#093A5B" stopOpacity="0.2" />
//                   <stop offset="50%" stopColor="#0F9D92" stopOpacity="0.4" />
//                   <stop offset="100%" stopColor="#0F9D92" stopOpacity="0.2" />
//                 </linearGradient>
//               </defs>
//               <line
//                 x1="10%"
//                 y1="50%"
//                 x2="90%"
//                 y2="50%"
//                 stroke="url(#workflowLineGradient)"
//                 strokeWidth="3"
//                 strokeDasharray="8,8"
//               />
//             </svg>

//             {/* GLOWING DOT (follows active step) */}
//             <motion.div
//               className="absolute top-1/2 w-3 h-3 rounded-full"
//               style={{
//                 left: `${dotLeftPercent}%`,
//                 transform: "translateY(-50%)",
//                 background:
//                   "linear-gradient(135deg, rgb(15,157,146), rgb(52,199,89))",
//                 boxShadow: "0 0 20px rgba(15,157,146, 0.9)",
//                 zIndex: 5,
//               }}
//               animate={{ scale: [1, 1.2, 1] }}
//               transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
//             />

//             {/* STEPS */}
//             <div
//               className="flex justify-between items-center relative"
//               style={{ paddingTop: 100 }}
//             >
//               {steps.map((step, idx) => {
//                 const isActive = idx === activeIndex;
//                 const isCompleted = idx < activeIndex;

//                 const circleBg = isActive
//                   ? `linear-gradient(135deg, ${step.color}, ${step.color}CC)`
//                   : "#FFFFFF";

//                 const circleBorder = isActive
//                   ? `3px solid ${step.color}`
//                   : isCompleted
//                     ? `3px solid ${step.color}55`
//                     : "3px solid rgb(229,229,234)";

//                 const circleShadow = isActive
//                   ? `${step.color}40 0px 10px 40px`
//                   : "0 5px 20px rgba(0,0,0,0.08)";

//                 const labelColor = isActive
//                   ? step.color
//                   : "rgb(134,134,139)";

//                 const statusBg = `rgba(88, 86, 214, 0.082)`;

//                 return (
//                   <div
//                     key={step.key}
//                     className="flex flex-col items-center flex-1 relative"
//                     style={{ minWidth: `${stepWidth}%` }}
//                   >
//                     {/* CIRCLE + GLOW */}
//                     <motion.div
//                       className="relative mb-6"
//                       animate={{ scale: isActive ? 1.15 : 1 }}
//                       transition={{ type: "spring", stiffness: 260, damping: 20 }}
//                     >
//                       {isActive && (
//                         <div
//                           className="absolute inset-0 rounded-full"
//                           style={{
//                             background: "rgba(88, 86, 214, 0.125)",
//                             filter: "blur(10px)",
//                             transform: "scale(1.4)",
//                           }}
//                         />
//                       )}
//                       <button
//                         type="button"
//                         onClick={() => handleStepClick(idx)}
//                         className="relative w-20 h-20 rounded-full flex items-center justify-center cursor-pointer"
//                         style={{
//                           background: circleBg,
//                           border: circleBorder,
//                           boxShadow: circleShadow,
//                         }}
//                       >
//                         <span
//                           style={{
//                             fontSize: "2rem",
//                             filter: isActive
//                               ? "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
//                               : "none",
//                           }}
//                         >
//                           {step.icon}
//                         </span>
//                       </button>
//                     </motion.div>

//                     {/* LABELS (clickable as well if you want) */}
//                     <div
//                       className="text-center"
//                       style={{
//                         color: labelColor,
//                         transform: isActive ? "scale(1.05)" : "scale(1)",
//                         transition: "all 0.25s ease",
//                       }}
//                     >
//                       <div
//                         style={{
//                           fontSize: "1.125rem",
//                           fontWeight: 600,
//                           marginBottom: 4,
//                         }}
//                       >
//                         {step.title}
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "0.8125rem",
//                           color: "rgb(134,134,139)",
//                         }}
//                       >
//                         {step.subtitle}
//                       </div>
//                     </div>

//                     {/* TOOLTIP CARD FOR ACTIVE STEP */}
//                     {isActive && (
//                       <motion.div
//                         className="absolute bg-white rounded-2xl p-3 shadow-2xl"
//                         style={{
//                           top: 200,
//                           width: 280,
//                           left: "50%",
//                           marginLeft: -140,
//                           border: `2px solid ${step.color}30`,
//                         }}
//                         initial={{ opacity: 0, y: 10 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         exit={{ opacity: 0, y: 10 }}
//                         transition={{ duration: 0.25 }}
//                       >
//                         <div
//                           className="text-[--color-text-primary] mb-3"
//                           style={{ fontSize: "1.125rem", fontWeight: 600 }}
//                         >
//                           {step.phaseTitle}
//                         </div>
//                         <div
//                           className="text-[--color-text-secondary] mb-4"
//                           style={{ fontSize: "0.875rem", lineHeight: 1.5 }}
//                         >
//                           {step.description}
//                         </div>
//                         <div className="flex items-center justify-between">
//                           <span
//                             className="text-[--color-text-muted]"
//                             style={{ fontSize: "0.75rem" }}
//                           >
//                             Status
//                           </span>
//                           <span
//                             className="px-3 py-1 rounded-full"
//                             style={{
//                               background: statusBg,
//                               color: step.color,
//                               fontSize: "0.75rem",
//                               fontWeight: 600,
//                             }}
//                           >
//                             {step.statusLabel}
//                           </span>
//                         </div>
//                       </motion.div>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

export default function WorkflowMockup() {
  const [progress, setProgress] = useState(0); // 0 → 100 loop

  // Auto-animate progress like before
  useEffect(() => {
    const id = setInterval(() => {
      setProgress((p) => (p >= 100 ? 0 : p + 2));
    }, 120);
    return () => clearInterval(id);
  }, []);

  const steps = [
    {
      key: "todo",
      title: "To Do",
      subtitle: "Step 1",
      phaseTitle: "To Do Phase",
      description: "Task created and waiting to be started",
      statusLabel: "Active",
      icon: "📋",
      color: "#5856D6", // purple
    },
    {
      key: "in-progress",
      title: "In Progress",
      subtitle: "Step 2",
      phaseTitle: "In Progress Phase",
      description: "Work has started and is moving ahead",
      statusLabel: "Ongoing",
      icon: "⚡",
      color: "#FF9500", // amber / lightning feel
    },
    {
      key: "review",
      title: "Under Review",
      subtitle: "Step 3",
      phaseTitle: "Review Phase",
      description: "Outputs are being checked before closure",
      statusLabel: "In review",
      icon: "👁️",
      color: "#AF52DE", // soft violet
    },
    {
      key: "closed",
      title: "Closed",
      subtitle: "Step 4",
      phaseTitle: "Closed Phase",
      description: "Task is completed and marked as closed",
      statusLabel: "Done",
      icon: "✓",
      color: "#34C759", // green
    },
  ];

  const stepWidth = 100 / steps.length;
  const activeIndex = Math.min(
    steps.length - 1,
    Math.floor((progress / 100) * steps.length)
  );

  // Line goes from 10% → 90%, so dot travels across that span
  const dotLeftPercent = 10 + (progress / 100) * 80;

  // 🔑 NEW: handle click on a step (keeps auto animation intact)
  const handleStepClick = (idx) => {
    setProgress((currentProgress) => {
      const currentIndex = Math.min(
        steps.length - 1,
        Math.floor((currentProgress / 100) * steps.length)
      );

      // If clicking same step → go to next step (with wrap)
      const targetIndex =
        currentIndex === idx ? (idx + 1) % steps.length : idx;

      // Convert step index → progress (0,25,50,75…)
      return (targetIndex / steps.length) * 100;
    });
  };

  return (
    <div className="p-4 sm:p-8 md:p-12 lg:p-16">
      {/* Optional: keep the mock window bar for consistency */}
      <div className="flex items-center px-5 mb-2">{/* ... */}</div>

      <div className="p-6 md:p-10">
        <div className="text-gray-900 mb-8 text-xl md:text-2xl font-semibold text-center">
          Simple, clear workflow to complete a task
        </div>

        <div className="relative min-h-[380px]">
          {/* DASHED GRADIENT LINE */}
          <div className="relative">
            <svg
              className="absolute top-1/2 left-0 w-full h-2 -translate-y-1/2"
              style={{ zIndex: 0 }}
            >
              <defs>
                <linearGradient
                  id="workflowLineGradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="0%"
                >
                  <stop offset="0%" stopColor="#093A5B" stopOpacity="0.2" />
                  <stop offset="50%" stopColor="#0F9D92" stopOpacity="0.4" />
                  <stop offset="100%" stopColor="#0F9D92" stopOpacity="0.2" />
                </linearGradient>
              </defs>
              <line
                x1="10%"
                y1="50%"
                x2="90%"
                y2="50%"
                stroke="url(#workflowLineGradient)"
                strokeWidth="3"
                strokeDasharray="8,8"
              />
            </svg>

            {/* GLOWING PROGRESS DOT */}
            <motion.div
              className="absolute top-1/2 w-3 h-3 rounded-full"
              style={{
                left: `${dotLeftPercent}%`,
                transform: "translateY(-50%)",
                background:
                  "linear-gradient(135deg, rgb(15,157,146), rgb(52,199,89))",
                boxShadow: "0 0 20px rgba(15,157,146, 0.9)",
                zIndex: 5,
              }}
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
            />

            {/* STEPS */}
            <div
              className="flex justify-between items-center relative"
              style={{ paddingTop: 100 }}
            >
              {steps.map((step, idx) => {
                const isActive = idx === activeIndex;
                const isCompleted = idx < activeIndex;

                const circleBg = isActive
                  ? `linear-gradient(135deg, ${step.color}, ${step.color}CC)`
                  : "#FFFFFF";

                const circleBorder = isActive
                  ? `3px solid ${step.color}`
                  : isCompleted
                    ? `3px solid ${step.color}55`
                    : "3px solid rgb(229,229,234)";

                const circleShadow = isActive
                  ? `${step.color}40 0px 10px 40px`
                  : "0 5px 20px rgba(0,0,0,0.08)";

                const labelColor = isActive
                  ? step.color
                  : "rgb(134,134,139)";

                const statusBg = `rgba(88, 86, 214, 0.082)`; // soft pill; looks fine for all

                return (
                  <div
                    key={step.key}
                    className="flex flex-col items-center flex-1 relative"
                    style={{ minWidth: `${stepWidth}%` }}
                  >
                    {/* CIRCLE + GLOW */}
                    <motion.div
                      className="relative mb-6"
                      animate={{ scale: isActive ? 1.15 : 1 }}
                      transition={{
                        type: "spring",
                        stiffness: 260,
                        damping: 20,
                      }}
                    >
                      {isActive && (
                        <div
                          className="absolute inset-0 rounded-full"
                          style={{
                            background: "rgba(88, 86, 214, 0.125)",
                            filter: "blur(10px)",
                            transform: "scale(1.4)",
                          }}
                        />
                      )}
                      <div
                        className="relative w-20 h-20 rounded-full flex items-center justify-center cursor-pointer"
                        style={{
                          background: circleBg,
                          border: circleBorder,
                          boxShadow: circleShadow,
                        }}
                        onClick={() => handleStepClick(idx)} // 🔹 NEW
                      >
                        <span
                          style={{
                            fontSize: "2rem",
                            filter: isActive
                              ? "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
                              : "none",
                          }}
                        >
                          {step.icon}
                        </span>
                      </div>
                    </motion.div>

                    {/* LABELS */}
                    <div
                      className="text-center"
                      style={{
                        color: labelColor,
                        transform: isActive ? "scale(1.05)" : "scale(1)",
                        transition: "all 0.25s ease",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "1.125rem",
                          fontWeight: 600,
                          marginBottom: 4,
                        }}
                      >
                        {step.title}
                      </div>
                      <div
                        style={{
                          fontSize: "0.8125rem",
                          color: "rgb(134,134,139)",
                        }}
                      >
                        {step.subtitle}
                      </div>
                    </div>

                    {/* TOOLTIP CARD FOR ACTIVE STEP */}
                    {isActive && (
                      <motion.div
                        className="absolute bg-white rounded-2xl p-3 shadow-2xl"
                        style={{
                          top: 200,
                          width: 280,
                          left: "50%",
                          marginLeft: -140,
                          border: `2px solid ${step.color}30`,
                        }}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{ duration: 0.25 }}
                      >
                        <div
                          className="text-[--color-text-primary] mb-3"
                          style={{ fontSize: "1.125rem", fontWeight: 600 }}
                        >
                          {step.phaseTitle}
                        </div>
                        <div
                          className="text-[--color-text-secondary] mb-4"
                          style={{ fontSize: "0.875rem", lineHeight: 1.5 }}
                        >
                          {step.description}
                        </div>
                        <div className="flex items-center justify-between">
                          <span
                            className="text-[--color-text-muted]"
                            style={{ fontSize: "0.75rem" }}
                          >
                            Status
                          </span>
                          <span
                            className="px-3 py-1 rounded-full"
                            style={{
                              background: statusBg,
                              color: step.color,
                              fontSize: "0.75rem",
                              fontWeight: 600,
                            }}
                          >
                            {step.statusLabel}
                          </span>
                        </div>
                      </motion.div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// ============================
//  Roles Mockup
// ============================
// function RolesMockup() {
//   const [activeRole, setActiveRole] = useState(0);
//   const roles = ["Admin", "Manager", "Member", "Client"];

//   const roleContent = {
//     Admin: ["Full system access", "Billing & upgrades", "User management", "All modules"],
//     Manager: ["Team oversight", "Approve requests", "Assign tasks", "Reports"],
//     Member: ["My tasks", "My calendar", "Team chat", "Documents"],
//     Client: ["View progress", "Shared files", "Status updates", "Messages"],
//   };

//   useEffect(() => {
//     const id = setInterval(() => {
//       setActiveRole((r) => (r + 1) % roles.length);
//     }, 3000);

//     return () => clearInterval(id);
//   }, []);

//   return (
//     <div
//       className="rounded-3xl p-4 sm:p-8 md:p-12 lg:p-16 "
//       style={{
//         background: "linear-gradient(135deg, #F5F5F7, #E8E8ED)",
//         boxShadow: "0px 20px 80px rgba(9,58,91,0.12)",
//       }}
//     >
//       {/* Top bar */}
//       <div
//         className="rounded-t-3xl flex items-center px-5"
//         style={{ height: "40px", background: "#093A5B" }}
//       >
//         <div className="flex gap-2">
//           <div className="w-3 h-3 rounded-full bg-white/30"></div>
//           <div className="w-3 h-3 rounded-full bg-white/30"></div>
//           <div className="w-3 h-3 rounded-full bg-white/30"></div>
//         </div>
//       </div>

//       {/* Main content */}
//       <div
//         className="bg-white rounded-b-xl p-2 md:p-8  min-h-[350px]"
//       // style={{ minHeight: "400px" }}
//       >
//         {/* Tabs */}
//         <div className="grid grid-cols-2 gap-2 mb-6 sm:mb-8 sm:flex 


//         :flex-row sm:flex-wrap sm:gap-2">
//           {roles.map((role, idx) => (
//             <motion.button
//               key={role}
//               className={`w-full rounded-lg px-2 py-1 text-sm sm:w-auto sm:px-5 sm:py-2.5 sm:text-base transition
//     ${activeRole === idx
//                   ? "bg-[--color-primary] text-black shadow-md"
//                   : "bg-white border border-black/10 text-[--color-text-primary] hover:bg-[--color-bg-gray]"
//                 }`}
//               onClick={() => setActiveRole(idx)}
//             >
//               {role}
//             </motion.button>
//           ))}
//         </div>

//         {/* Role Content */}
//         <AnimatePresence mode="wait">
//           <motion.div
//             key={activeRole}
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             exit={{ opacity: 0, y: -20 }}
//             transition={{ duration: 0.3 }}
//             className="space-y-4"
//           >
//             {roleContent[roles[activeRole]].map((item, idx) => (
//               <motion.div
//                 key={idx}
//                 className="flex items-center gap-4 p-2 sm:p-4 bg-[--color-bg-gray] rounded-xl"
//                 initial={{ opacity: 0, x: -20 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 transition={{ delay: idx * 0.1 }}
//               >
//                 <span className="text-[--color-primary]" style={{ fontSize: "1.25rem" }}>
//                   ✓
//                 </span>
//                 <span className="text-[--color-text-primary]">{item}</span>
//               </motion.div>
//             ))}
//           </motion.div>
//         </AnimatePresence>
//       </div>
//     </div>
//   );
// }

function RolesMockup() {
  const roles = [
    {
      key: "admin",
      label: "Admin",
      icon: "👑",
      color: "#5856D6",
      features: [
        {
          icon: "🧭",
          title: "Full system access",
          subtitle: "Configure every workspace setting",
        },
        {
          icon: "💳",
          title: "Billing & upgrades",
          subtitle: "Manage plans, invoices & renewals",
        },
        {
          icon: "🧑‍🤝‍🧑",
          title: "User management",
          subtitle: "Invite, suspend & assign roles",
        },
        {
          icon: "📦",
          title: "All modules",
          subtitle: "Access every Simplifyte feature",
        },
      ],
    },
    {
      key: "manager",
      label: "Manager",
      icon: "📋",
      color: "#FF9500",
      features: [
        {
          icon: "📊",
          title: "Team oversight",
          subtitle: "See who is working on what",
        },
        {
          icon: "✅",
          title: "Approve requests",
          subtitle: "Review changes & approvals",
        },
        {
          icon: "📌",
          title: "Assign tasks",
          subtitle: "Distribute work in a few clicks",
        },
        {
          icon: "📈",
          title: "Reports",
          subtitle: "Track output & bottlenecks",
        },
      ],
    },
    {
      key: "member",
      label: "Member",
      icon: "⚡",
      color: "#34C759",
      features: [
        {
          icon: "🗂️",
          title: "My tasks",
          subtitle: "Stay focused on today’s work",
        },
        {
          icon: "📅",
          title: "My calendar",
          subtitle: "See deadlines & events together",
        },
        {
          icon: "💬",
          title: "Team chat",
          subtitle: "Discuss work without losing context",
        },
        {
          icon: "📄",
          title: "Documents",
          subtitle: "Access all linked files instantly",
        },
      ],
    },
    {
      key: "client",
      label: "Client",
      icon: "👤",
      color: "#5856D6",
      features: [
        {
          icon: "👀",
          title: "View progress",
          subtitle: "Track your work at a glance",
        },
        {
          icon: "📁",
          title: "Shared files",
          subtitle: "Secure access to documents",
        },
        {
          icon: "🔔",
          title: "Status updates",
          subtitle: "Stay informed without chasing",
        },
        {
          icon: "✉️",
          title: "Messages",
          subtitle: "Talk directly to the team",
        },
      ],
    },
  ];

  const [activeRoleIndex, setActiveRoleIndex] = useState(0);

  // 🔁 Auto-rotate roles every 3 seconds
  useEffect(() => {
    const id = setInterval(() => {
      setActiveRoleIndex((prev) => (prev + 1) % roles.length);
    }, 3000);
    return () => clearInterval(id);
  }, [roles.length]);

  const activeRole = roles[activeRoleIndex];

  const handleRoleClick = (index) => {
    setActiveRoleIndex(index);
  };

  return (
    <div className="relative min-h-[550px] flex flex-col items-center justify-center">
      {/* Soft radial glow in the back */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full blur-3xl opacity-20 -z-10"
        style={{
          background:
            "radial-gradient(circle, rgb(88,86,214), transparent 70%)",
        }}
      />

      {/* Role buttons row */}
      <div className="flex justify-center gap-4 mb-10 sm:mb-16">
        {roles.map((role, idx) => {
          const isActive = idx === activeRoleIndex;
          return (
            <button
              key={role.key}
              type="button"
              className="relative"
              onClick={() => handleRoleClick(idx)}
            >
              {isActive && (
                <motion.div
                  className="absolute inset-0 rounded-2xl"
                  style={{
                    background: "rgba(88, 86, 214, 0.082)",
                    border: "2px solid rgb(88, 86, 214)",
                  }}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.25 }}
                />
              )}

              <div className="relative flex flex-col items-center gap-2 px-4 sm:px-6 py-3 sm:py-4">
                <div className="text-3xl sm:text-4xl">{role.icon}</div>
                <span
                  className="whitespace-nowrap"
                  style={{
                    fontSize: "0.9375rem",
                    fontWeight: 600,
                    color: isActive ? "rgb(88,86,214)" : "rgb(134,134,139)",
                  }}
                >
                  {role.label}
                </span>
              </div>
            </button>
          );
        })}
      </div>

      {/* Main role card */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeRole.key}
          className="bg-white rounded-3xl shadow-2xl overflow-hidden w-full max-w-3xl"
          style={{
            border: "2px solid rgba(88, 86, 214, 0.125)",
          }}
          initial={{ opacity: 0, y: 20, rotateX: -5 }}
          animate={{ opacity: 1, y: 0, rotateX: 0 }}
          exit={{ opacity: 0, y: -20, rotateX: 5 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
        >
          {/* Gradient header */}
          <div className="relative p-6 sm:p-8 bg-gradient-to-r from-purple-500 to-indigo-500 overflow-hidden">
            <div
              className="absolute inset-0 opacity-20"
              style={{
                backgroundImage:
                  "radial-gradient(circle at 20px 20px, white 2px, transparent 0)",
                backgroundSize: "40px 40px",
                transform: "translate(6px, 6px)",
              }}
            />
            <div className="relative flex items-center gap-4">
              <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
                <span className="text-3xl sm:text-[2.5rem]">
                  {activeRole.icon}
                </span>
              </div>
              <div>
                <h3
                  className="text-white"
                  style={{ fontSize: "2rem", fontWeight: 700 }}
                >
                  {activeRole.label}
                </h3>
                <p
                  className="text-white/90"
                  style={{ fontSize: "1rem" }}
                >
                  Role permissions &amp; capabilities
                </p>
              </div>
            </div>
          </div>

          {/* Features grid */}
          <div className="p-6 sm:p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {activeRole.features.map((feature, idx) => (
                <motion.div
                  key={feature.title}
                  className="group p-5 rounded-2xl bg-[--color-bg-gray] hover:bg-gray-100 cursor-pointer transition-all"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.05 }}
                >
                  <div className="flex items-start gap-4">
                    <div
                      className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center"
                      style={{
                        background: "rgba(88, 86, 214, 0.082)",
                      }}
                    >
                      <span style={{ fontSize: "1.5rem" }}>
                        {feature.icon}
                      </span>
                    </div>
                    <div className="flex-1">
                      <div
                        className="text-[--color-text-primary] mb-1"
                        style={{ fontSize: "1.0625rem", fontWeight: 600 }}
                      >
                        {feature.title}
                      </div>
                      <div
                        className="text-[--color-text-muted]"
                        style={{ fontSize: "0.875rem" }}
                      >
                        {feature.subtitle}
                      </div>
                    </div>
                    <div
                      className="opacity-0 group-hover:opacity-100 transition-opacity"
                      style={{
                        color: "rgb(88, 86, 214)",
                        transform: "translateX(-5px)",
                      }}
                    >
                      →
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
